import axiosInstance from '../store/axiosInterceptor';

export interface CoachTargetDetail {
  coach_id: string;
  coach_name: string;
  completed_sessions: number;
  sessions_remaining: number;
  percentage: number;
}

export interface DashboardStats {
  total_coaches: number;
  total_students: number;
  active_engagements: number;
  upcoming_sessions: number;
  pending_requests: number;
  open_reports: number;
  coaches_nearing_target: number;
  coaches_nearing_target_details: CoachTargetDetail[];
}

class DashboardService {
  async getDashboardStats(): Promise<DashboardStats> {
    try {
      const response = await axiosInstance.get<DashboardStats>('/api/admin/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
      throw error;
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
